export default __webpack_public_path__ + "static/media/chevron_right.0db8c3fa.svg";